export default __webpack_public_path__ + "static/integrations_hydrogen-bfd3f4041ce4c77429033392abe3f6c7.png";